<script>
import mixin from '@/plans/mx/shopping-cart';
import planCommon from './mixin';

export default {
  mixins: [planCommon, mixin],
  methods: {
    getPlanQuantity(plan) {
      return plan?.cartInfo?.selected_number || 0
    },
    getPlanAmount(plan) {
      const amount = plan?.amount || 0
      return this.$money(this.getPlanQuantity(plan) * amount)
    },
    $renderPrice() {
      if (!this.mx_plans.length) return null

      return (
        <div class="opc-cart-item desk-phone-cart">
          {this.mx_title(this.$t('billing.hw.desk_phones.addon.title'))}
          {
            this.mx_plans.map((plan) => {
              return (
                <div key={plan.plan_code} class="desk-phone-cart-item">
                  <div class="desk-phone-cart__row desk-phone-cart__row-subtitle"> 
                    <span>{`${plan.planName} ${this.$t('billing.hw.desk_phones.addon.title')}`}</span>
                    <span>{ this.getPlanAmount(plan) }</span>
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text"> 
                    { this.$t('billing.hw.desk_phones.cart.period') }
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text"> 
                    { this.$t('billing.quantity')}: { this.getPlanQuantity(plan) }
                  </div>
                </div>
              );
            })
          }
          <div class="desk-phone-cart__shipping"> 
            <span>{ this.$t('billing.hw.desk_phones.cart.shipped_from') }</span>
            <span>{ this.$t('billing.hw.desk_phones.cart.shipped_free') }</span>
          </div>
          <div class="desk-phone-cart__privacy hide-in-success">
            <zm-button type="link" href={this.mx_privacyPolicy} target="_blank">{this.$t('billing.hw.desk_phones.cart.privacy')}</zm-button>
            <span> | </span>
            <zm-button type="link" href={this.mx_returnPolicy} target="_blank">{this.$t('billing.hw.desk_phones.cart.return_policy')}</zm-button>
          </div>
          <div class="only-show-in-success desk-phone-cart__privacy">
            <zm-button type="link" class="opc-success-no-hide-button" href={this.mx_rmaUrl} target="_blank">{ this.$t('billing.hw.ram') }</zm-button>
            <span> | </span>
            <zm-button type="link" class="opc-success-no-hide-button" href={this.mx_helpUrl} target="_blank">{ this.$t('billing.hw.support_form') }</zm-button>
          </div>
        </div>
      )
    }
  },
};
</script>
<style lang="scss" scoped>
.only-show-in-success {
  display: none;
}
</style>
<style lang="scss">
.desk-phone-cart {
  .desk-phone-cart-item {
    margin-bottom: 10px;
  }
  &__row {
    display: flex;
    justify-content: space-between;

    color: #515079;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */

    &-subtitle {
      font-weight: 600;
      color: #00053D;
    }
  }
  &__shipping {
    display: flex;
    justify-content: space-between;


    color: #00053D;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 21px */
  }
  &__privacy {
    color: #515079;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
}
</style>
